import {Box, Divider, Typography} from '@mui/material';
import React from 'react';

import {t} from 'i18next';
import './ReviewProgressSummary.scss';

interface ReviewProgressSummaryProps {
  reviewerProgressSummary: any;
}

const ReviewProgressSummary: React.FC<ReviewProgressSummaryProps> = ({
  reviewerProgressSummary,
}) => {
  const stringPath = 'reports.reviewProgressReviewer.summary.';
  const summaryData = [
    {
      label: t(stringPath + 'selected_reveiwer_count'),
      value: reviewerProgressSummary.selected_reveiwer_count,
    },
    {
      label: t(stringPath + 'assignedDocs'),
      value: reviewerProgressSummary.assignedDocs,
    },
    {
      label: t(stringPath + 'completedDocs'),
      value: reviewerProgressSummary.completedDocs,
    },
    {
      label: t(stringPath + 'remainingDocs'),
      value: reviewerProgressSummary.remainingDocs,
    },
    {
      label: t(stringPath + 'percentage_Completed_report'),
      value: `${reviewerProgressSummary.percentage_Completed_report}%`,
    },
    {
      label: t(stringPath + 'estimated_Total_Review_Spent_report'),
      value: reviewerProgressSummary.estimated_Total_Review_Spent_report,
    },
    {
      label: t(stringPath + 'estimated_Remaining_Time_report'),
      value: reviewerProgressSummary.estimated_Remaining_Time_report,
    },
    {
      label: t(stringPath + 'tagged_Responsive'),
      value: reviewerProgressSummary.tagged_Responsive,
    },
    {
      label: t(stringPath + 'tagged_Privileged'),
      value: reviewerProgressSummary.tagged_Privileged,
    },
  ];
  return (
    <Box className="review-summary-container">
      {summaryData.map((item, index) => (
        <Box key={item.label}>
          <Box className="review-row">
            <Typography
              className="typo-text body3_size custom-text"
              data-testid={`review-progress-summary-label-${index}`}
            >
              {item.label}
            </Typography>

            <Typography
              className="typo-text label2_size custom-text-value"
              data-testid={`review-progress-summary-value-${index}`}
            >
              {item.value}
            </Typography>
          </Box>

          {/* Divider except last row in each column */}
          {index % 5 !== 4 && <Divider className="custom-divider" />}
        </Box>
      ))}
    </Box>
  );
};

export default ReviewProgressSummary;
